import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-paginator',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslatePipe],
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.css',
})
export class PaginatorComponent {
  page = input(0);
  total = input(0);
  pageSize = input(10);
  setPage = input<(page: number) => void>(() => {});
  setPageSize = input<(size: number) => void>(() => {});
  labelSingular = input('registro');
  labelPlural = input('registros');

  get totalPages(): number {
    return Math.ceil(this.total() / this.pageSize()) || 1;
  }

  get hasNextPage(): boolean {
    return this.page() < this.totalPages - 1;
  }

  get hasPreviousPage(): boolean {
    return this.page() > 0;
  }

  get pageNumbers(): number[] {
    const pages: number[] = [];
    for (let i = 0; i < this.totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  get entityLabel(): string {
    return this.total() === 1 ? this.labelSingular() : this.labelPlural();
  }

  onPageSizeChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    this.setPageSize()(Number(select.value));
  }

  goToPage(page: number): void {
    this.setPage()(page);
  }

  nextPage(): void {
    if (this.hasNextPage) {
      this.setPage()(this.page() + 1);
    }
  }

  previousPage(): void {
    if (this.hasPreviousPage) {
      this.setPage()(this.page() - 1);
    }
  }
}
